// User-facing copy: home. Moved from the web app (pages/Home.tsx, prerender.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** pages/Home.tsx */
export const page = {
    pagematesHome: "Pagemates home",
    signIn: "Sign in",
    aBookClubWhere: "A book club where nobody spoils the ending.",
    readAtYourOwn: "Read at your own pace, see where everyone's up to, and talk about the book without ruining it for anyone behind you.",
    startAClub: "Start a club",
    findAClub: "Find a club",
    freeSignInWith: "Free. Sign in with Discord, Google or Apple.",
    howItWorks: "How it works",
    aClubTakesAbout: "A club takes about a minute to start.",
    startAClubAnd: "Start a club and send your friends a link.",
    everyoneReadsAtTheir: "Everyone reads at their own speed, and you can see where they are.",
    meetUpInPerson: "Meet up, in person or online, with the questions everyone saved along the way.",
    whatYouGet: "What you get",
    theQuestionsEveryBook: "The questions every book club asks.",
    whatIfMyFriends: "What if my friends read faster than me?",
    theirCommentsWaitFor: "Their comments wait for you. When you catch up, they open. They can even leave you a note at a page, and it's waiting when you get there.",
    page60: "page 60",
    theLettersInChapter: "The letters in chapter four change everything.",
    hiddenUntilPage180: "Hidden until page 180",
    theoLeftYouA: "Theo left you a note at page 150",
    howDoWeKnow: "How do we know if we'll finish in time?",
    everyoneSPlaceIn: "Everyone's place in the book shows on one line, with a gentle goal for each meeting. Nobody gets nagged.",
    goalForThursday: "Goal for Thursday",
    you: "You",
    about20PagesA: "About 20 pages a day gets you there by Thursday.",
    howDoWeChoose: "How do we choose the next book?",
    anyoneCanSuggestOne: "Anyone can suggest one. Then whoever runs the club picks, everyone votes, or you take turns.",
    points: (pts) => `${pts} points`,
    n4Of5Have: "4 of 5 have voted.",
    whatHappensAtThe: "What happens at the meeting?",
    questionsPeopleSavedWhile: "Questions people saved while reading become the agenda, and anyone can take notes for the club.",
    wasTheGardenerLying: "Was the gardener lying the whole time?",
    whyDoesTheOrchard: "Why does the orchard only grow at night?",
    wouldYouHaveOpened: "Would you have opened the last letter?",
    thursday630Pm: "Thursday, 6:30 PM · 4 going",
    whatDoWeEnd: "What do we end up with?",
    everyBookYouVe: "Every book you've read together, with everyone's ratings and favourite quotes, and the guesses you each made at the start, opened when you finish.",
    samSGuessP: "Sam's guess · p. 20",
    theGardenerPlantedIt: "The gardener planted it for someone who never came back.",
    clubAverage: "Club average ",
    orJoinOneThat: "Or join one that's already reading.",
    someClubsWelcomeNew: "Some clubs welcome new members. Others are private, and you join with a link from a friend.",
    slowBooksFastOpinions: "Slow books, fast opinions.",
    n34MembersAbout20: "34 members · about 20 pages a day",
    oneBigClassicA: "One big classic a month, read slowly and together.",
    n57MembersRelaxedPace: "57 members · relaxed pace",
    scienceFictionAndThe: "Science fiction and the people who love arguing about it.",
    n128MembersFastPace: "128 members · fast pace",
    browseClubs: "Browse clubs",
    exampleClubsYouLl: "Example clubs. You'll see real ones after signing in.",
    questions: "Questions",
    goodToKnow: "Good to know",
    doesItCostAnything: "Does it cost anything?",
    no: "No.",
    whoCanSeeWhat: "Who can see what we write?",
    onlyPeopleInYour: "Only people in your club. Private clubs don't appear anywhere.",
    whatDoINeed: "What do I need to sign up?",
    aDiscordGoogleOr: "A Discord, Google or Apple account. We only use it to sign you in, and we never post anything for you.",
    isThereAnApp: "Is there an app?",
    itWorksInAny: "It works in any browser. On your phone, add it to your home screen and it behaves like an app.",
    whatSHardcover: "What's Hardcover?",
    aFreeSiteFor: "A free site for keeping track of what you read. If you use it, Pagemates can keep your place in the book up to date for you. You don't need it.",
    yourNextBookIs: "Your next book is better with company.",
    pagemates: "Pagemates",
    policyAndContact: "Policy and contact",
    tenPagesInAnd: "Ten pages in and I already love the narrator.",
    theFirstLetterMade: "The first letter made me go back and reread the opening.",
    waitSoTheGardener: "Wait, so the gardener knew all along?",
    thatNightInThe: "That night in the orchard is the best chapter so far.",
    iDidNotSee: "I did not see that last letter coming.",
    slowDownForThe: "Slow down for the next chapter. It's the one we'll talk about all night.",
    message: "message",
    messages: "messages",
    moreVisible: (d, x) => `${d} more ${x} visible`,
    hiddenAgain: (messages) => `${messages} hidden again`,
    leftYouANote: (name) => `${name} left you a note, and it opened`,
    theNoteIsWaiting: "The note is waiting again",
    hiddenUntilPage: (page) => `Hidden until page ${page}`,
    theGlassOrchard: "The Glass Orchard",
    aMadeUpBook: (BOOK_PAGES) => `A made-up book · ${BOOK_PAGES} pages · 5 readers`,
    leftThisForYou: (name, page) => `${name} left this for you at page ${page}`,
    aNoteFromIs: (name, page) => `A note from ${name} is waiting at page ${page}`,
    youVeReadTo: "You've read to ",
    page: (page) => `page ${page}`,
    ofShowing: (open, length) => `${open} of ${length} showing`,
    dragToSeeWhat: "Drag to see what you'd see. Every comment remembers how far its writer had read. You only see the ones you've caught up to.",
    northOfTheLighthouse: "North of the Lighthouse",
    theSaltArchive: "The Salt Archive",
    aYearOfSmall: "A Year of Small Rooms",
};
/** prerender.tsx */
export const prerender = {
    pagematesABookClub: "Pagemates · A book club where nobody spoils the ending",
    readAtYourOwn: "Read at your own pace, see where everyone's up to, and talk about the book without ruining it for anyone behind you. Free.",
    signInPagemates: "Sign in · Pagemates",
    signInToPagemates: "Sign in to Pagemates with Discord, Google or Apple.",
};
//# sourceMappingURL=home.js.map